import React from 'react'
import { langObj } from './langObj'
import styles from './lang.module.css'

export default function LangModal({change, closeModal}) {
  return (
    <div className={styles['lang-choose']}>
         <div className={styles['lang-items']} onClick={() => {change("arm"); closeModal()}}>
                 {langObj.arm}
         </div>
         <div className={styles['lang-items']} onClick={() => {change("eng"); closeModal()}}>
                 {langObj.eng}
         </div>
         <div className={styles['lang-items']}  onClick={() => {change("ru"); closeModal()}}>
                 {langObj.ru}
         </div>
    </div>
  )
}
